export const TOP_NEWS_BANNER_HISTORY_CONTENT = {
  changesMsg: 'изменений',
  pasteOnSite: 'Поставил на сайте: ',
  titleMsg: 'История изменений баннера'
}
